export const newReservationPath = (venueSlug: string) => `/v/${venueSlug}`

export const publicReservationPath = (reservationUuid: string) => `/r/${reservationUuid}`

export const panelPath = (venueSlug: string, path: string) => `/panel/${venueSlug}/${path}`
export const reservationEditPath = (venueSlug: string, reservationId: string | number) =>
  panelPath(venueSlug, `reservations/${reservationId}/edit`)
export const customerPath = (venueSlug: string, customerId: string | number) =>
  panelPath(venueSlug, `customers/${customerId}`)
export const venueSettingsPath = (venueSlug: string) => panelPath(venueSlug, "settings")
export const staffMemberPath = (venueSlug: string, userId: string | number) => panelPath(venueSlug, `staff/${userId}`)
